import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const NutrientsIncreaseIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 600 600" {...rest}>
      <defs>
        <style>{`.cls-nutrient-increase-icon-1{fill:${
          color ?? "#5dbbce"
        };}.cls-nutrient-increase-icon-2{fill:#fff;}`}</style>
      </defs>
      <path
        className="cls-nutrient-increase-icon-1"
        d="M271.69,105.66,47.29,494.34c-12.58,21.79,3.15,49,28.31,49H524.4c25.16,0,40.89-27.24,28.31-49L328.31,105.66C315.73,83.87,284.27,83.87,271.69,105.66Z"
      />
      <path
        className="cls-nutrient-increase-icon-2"
        d="M413.86,365.07v16A17.92,17.92,0,0,1,396,399H326.14a.26.26,0,0,0-.26.26v69.86A17.92,17.92,0,0,1,308,486.94H292a17.92,17.92,0,0,1-17.87-17.86V399.22a.26.26,0,0,0-.26-.26H204a17.92,17.92,0,0,1-17.87-17.87v-16A17.92,17.92,0,0,1,204,347.21h69.85a.26.26,0,0,0,.26-.26V277.09A17.91,17.91,0,0,1,292,259.23h16a17.91,17.91,0,0,1,17.87,17.86V347a.26.26,0,0,0,.26.26H396A17.92,17.92,0,0,1,413.86,365.07Z"
      />
    </svg>
  );
};
